import React from 'react';
import { useIntl } from 'react-intl';

import { QuestionTypeShowProps } from './QuestionShow';
import FormBudget from '../../../../../Forms/Common/FormBudget/FormBudget';
import useSpace from '../../../../../../../Hooks/useSpace';

export default function BudgetShow({
  question,
  errors,
  errorIndex,
  index,
  form,
  disabled,
  scope,
}: QuestionTypeShowProps) {
  const { control } = form;
  const { space } = useSpace();
  const intl = useIntl();
  const inputName = `${scope}answers_attributes.${index}.content`;
  const errorPath = `${scope}answers_attributes.${errorIndex}.content`;

  return (
    <FormBudget
      disabled={disabled}
      name={inputName}
      errorPath={errorPath}
      control={control}
      hiddenLabel
      errors={errors}
      errorIndex={errorIndex}
      currencySymbol={space?.currency?.symbol}
      required={question?.required}
      placeholder={intl.formatMessage({ id: 'POST_FORM.BUDGET_PLACEHOLDER' })}
    />
  );
}
